import React from "react";
import "./index.css";

function index() {
  return (
    <div>
      <h1 id="tituloHome">Sistema de Irrigação COPANGA</h1>
    </div>
  );
}

export default index;
